$(function() {
  const sideLinkCategoryTitle = $(".category-title")

  sideLinkCategoryTitle.click(function() {
    $(this).next().slideToggle()
  })
})
